import { maxLengthValidation, requiredWithMaxLengthValidation } from '@/global/validators';
import { z } from 'zod';

export const EMAIL_CAMPAIGN_FORM_SCHEMA = z
  .object({
    name: requiredWithMaxLengthValidation(300),
    description: maxLengthValidation(3000),
    templateId: z.string().min(1, 'campaign:whatsappTemplateRequired'),
    templateName: z.string().optional(),
    templateData: z.record(z.any()).optional(),
    audienceId: z.string().min(1, 'campaign:audienceRequired'),
    connectorFlowId: z.string().min(1, 'campaign:connectorFlowRequired'),
    connectorId: z.string().min(1, 'campaign:connectorRequired'),
    scheduleType: z.enum(['sendNow', 'schedule']).default('sendNow'),
    scheduleStart: z.preprocess((value) => {
      if (!value) return undefined;
      return value instanceof Date ? value : new Date(value as string);
    }, z.date().optional()),
    scheduleEnd: z.preprocess((value) => {
      if (!value) return undefined;
      return value instanceof Date ? value : new Date(value as string);
    }, z.date().optional()),
  })
  .superRefine((data, ctx) => {
    if (data.scheduleType === 'schedule' && !data.scheduleStart) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['scheduleStart'],
        message: 'campaign:scheduleDateRequired',
      });
    }
    if (data.scheduleStart && data.scheduleEnd && data.scheduleEnd <= data.scheduleStart) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['scheduleEnd'],
        message: 'campaign:scheduleEndMustBeAfterStart',
      });
    }
  });

export type EmailCampaignFormInput = z.input<typeof EMAIL_CAMPAIGN_FORM_SCHEMA>;
export type EmailCampaignFormOutput = z.output<typeof EMAIL_CAMPAIGN_FORM_SCHEMA>;

export type EmailCampaignStep = 'TitleDescription' | 'AudienceSelection' | 'TemplateSelection' | 'Mapping' | 'PreviewSchedule';
